import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';

import { FrontendSizeInputComponent } from '@tablesready/frontend-size-input';
import { FormValidationModule } from '@tablesready/common-ui';
import { DurationComponent } from './duration.component';

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    FormValidationModule,
    FrontendSizeInputComponent,
  ],
  declarations: [DurationComponent],
  exports: [DurationComponent],
})
export class DurationModule {
}
